export default "__VITE_ASSET__cd52361b__"